import React, { useState } from 'react';
import './EnquiryFormSection.css';
import waveBg from '../../Assets/rock-bg.png';

const formSections = [
  {
    title: 'General Inquiry Form',
    fields: [
      'First Name',
      'Last Name',
      'Email Address',
      'Company/Organization',
      'Contact Number',
      'Subject'
    ],
  },
  {
    title: 'Vendor / Vendor Onboarding',
    fields: [
      'Vendor Name',
      'Email Address',
      'Phone Number',
      'Business Type',
      'Location',
      'Service Description' // <-- Added field
    ],
  },
  {
    title: 'Foundation / CSR Partnerships',
    fields: [
      'Organization Name',
      'Contact Person',
      'Email',
      'Contact Number',
      'Proposal Summary',
      'Website / Portfolio Link' // <-- Added field
    ],
  },
  {
    title: 'Career Inquiry / Job Follow-up',
    fields: [
      'Full Name',
      'Email',
      'Position Applied',
      'Contact Number',
      'Cover Letter / Message',
      'Resume Link / Attachment' // <-- Added field
    ],
  }
];


const EnquiryFormSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="enquiry-form-wrapper">
      {/* <div className="top-bg-image"></div>  */}

      {formSections.map((section, index) => (
        <div className="accordion-section" key={index}>
          <button
            className={`accordion-header ${activeIndex === index ? 'active' : ''}`}
            onClick={() => toggleAccordion(index)}
          >
            {section.title}
            {/* <span className="arrow">{activeIndex === index ? '▲' : '▼'}</span> */}
          </button>
          {activeIndex === index && (
            <div className="accordion-body">
              <h3 className="form-heading">
                <span className='enquiry-text'>ENQUIRY FORM</span><br />
                <span><span className="highlight">TAKE THE</span> FIRST STEP</span>
              </h3>
              <form className="custom-form">
                {section.fields.map((field, i) => (
                  <div className="form-group" key={i}>
                    <label>{field}</label>
                    <input type="text" />
                  </div>
                ))}
                <div className="button-wrapper">
  <button type="submit" className="explore-btn">Submit</button>
</div>
              </form>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default EnquiryFormSection;
